module.exports = __webpack_public_path__ + "static/media/anmolkhem.0a27ce53.jpeg";